import React, { useEffect, useState, useRef } from 'react';
import './featured-availability-tabs.css';
import { useCookies } from 'react-cookie';
import { useIntersection } from '../../../hooks/use-intersection-hook';
import { useIntl } from 'react-intl';
import FeaturedItemGallery from '../featured-item/featured-item-gallery';
import ProductAvailabilityTable from '../product-availability/product-availability-table';
import {
    getProdudctAvailabilityData,
    getLastUpdatedData,
} from '../../../api/product-availability-api';
import { IProductAvailabilityItem } from '../../../../../../../Application/TypewriterModels/IProductAvailabilityItem';
import { NEW_INDICATOR_COOKIE } from '../../common/constants';
export const FeaturedAvailabilityTabs: React.FC = () => {
    const intl = useIntl();
    const [productAvailabilityData, setProductAvailabilityData] = useState<
        IProductAvailabilityItem[]
    >([
        {
            product: '',
            availability: '',
            availabilityEng: '',
            latestUpdate: '',
            category: '',
        },
    ]);
    const [lastUpdated, setLastUpdated] = useState<string>('');
    const [cookies, setCookie] = useCookies([NEW_INDICATOR_COOKIE]);
    const productAvailabilityRef = useRef<HTMLDivElement | null>(null);
    const isProductAvailabilityTableVisible = useIntersection(
        productAvailabilityRef.current,
        '0px'
    );

    const isCookieUpdateNecessary =
        cookies.new_indicator !== lastUpdated.slice(0, 10);

    useEffect(() => {
        (async () => {
            const { data } = await getProdudctAvailabilityData();
            const { data: updated } = await getLastUpdatedData();

            if (data && updated) {
                setProductAvailabilityData(data);
                setLastUpdated(updated);
            }
        })();
    }, []);

    const setNewIndicatorCookie = (): void => {
        const expiration = new Date();
        expiration.setMonth(expiration.getMonth() + 3);
        setCookie(NEW_INDICATOR_COOKIE, lastUpdated.slice(0, 10), {
            expires: expiration,
            path: '/',
        });
    };

    if (isProductAvailabilityTableVisible && isCookieUpdateNecessary) {
        setNewIndicatorCookie();
    }

    return (
        <>
            {!(productAvailabilityData.length > 1) ? (
                <FeaturedItemGallery />
            ) : (
                <>
                    <ul className="nav nav-tabs">
                        <li className="active featured-tab">
                            <a data-toggle="tab" href="#featured-gallery">
                                <i className="far fa-lightbulb" />
                                <span className="tab-title">
                                    {intl.formatMessage({
                                        id: 'Featured_updates',
                                        defaultMessage: 'Featured Updates',
                                    })}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                data-toggle="tab"
                                href="#product-availability-table"
                            >
                                <i className="far fa-shopping-bag" />
                                <span className="tab-title">
                                    {intl.formatMessage({
                                        id: 'Product_availability',
                                        defaultMessage: 'Product Availability',
                                    })}
                                </span>
                                {isCookieUpdateNecessary && (
                                    <span className="tab-new-sign">
                                        {intl.formatMessage({
                                            id: 'New_home',
                                            defaultMessage: 'New',
                                        })}
                                    </span>
                                )}
                            </a>
                        </li>
                    </ul>
                    <div className="tab-content">
                        <div
                            id="featured-gallery"
                            className="tab-pane fade in active"
                        >
                            <FeaturedItemGallery
                                productAvailabilityData={
                                    productAvailabilityData
                                }
                            />
                        </div>
                        <div
                            ref={productAvailabilityRef}
                            id="product-availability-table"
                            className="tab-pane fade"
                        >
                            <ProductAvailabilityTable
                                productAvailabilityData={
                                    productAvailabilityData
                                }
                                lastUpdated={lastUpdated}
                            />
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default FeaturedAvailabilityTabs;
